import React from 'react';

const Choice = ({ id, choice, handleAnswer, selectedAnswer }) => {
  return (
    <span className="leading-8">
      {choice === " " ? (
        <span>&nbsp;&nbsp;</span>
      ) : (
        <button
          className={selectedAnswer === choice ? "crossed tracking-[.2rem]" : "tracking-[.2rem]"}
          id={`choice-${id}`}
          name="choices"
          value={id}
          onClick={() => {handleAnswer(choice);}}
          dangerouslySetInnerHTML={{__html: choice}}
        />
      )}
      
    </span>
  );
};

export default Choice;